/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AsyncJob } from '../models/AsyncJob';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminAsyncJobService {

    /**
     * get list of async jobs
     * @returns AsyncJob Success
     * @throws ApiError
     */
    public static listAsyncJobs({
        companyId,
        type,
        status,
        sort,
        limit,
        offset,
    }: {
        /**
         * Company ID
         */
        companyId: number,
        /**
         * Async Job type
         */
        type?: string,
        /**
         * Async Job status
         */
        status?: string,
        /**
         * Sort object
         */
        sort?: {
            companyName?: string;
            companyCode?: string;
            createdAt?: string;
            updatedAt?: string;
        },
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<Array<AsyncJob>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/asyncJob',
            query: {
                'companyId': companyId,
                'type': type,
                'status': status,
                'sort': sort,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * delete async job
     * @returns AsyncJob Success
     * @throws ApiError
     */
    public static deleteAsyncJob({
        id,
        companyId,
    }: {
        /**
         * Async Job ID
         */
        id: number,
        /**
         * Company ID
         */
        companyId: number,
    }): CancelablePromise<AsyncJob> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/asyncJob/{id}',
            path: {
                'id': id,
            },
            query: {
                'companyId': companyId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * cancel async job
     * @returns any Success
     * @throws ApiError
     */
    public static cancelAsyncJob({
        id,
        companyId,
    }: {
        /**
         * Async Job ID
         */
        id: number,
        /**
         * Company ID
         */
        companyId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/asyncJob/{id}/cancel',
            path: {
                'id': id,
            },
            query: {
                'companyId': companyId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get async job details
     * @returns any Success
     * @throws ApiError
     */
    public static getAsyncJobDetails({
        id,
        companyId,
    }: {
        /**
         * Async Job ID
         */
        id: number,
        /**
         * Company ID
         */
        companyId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/asyncJob/{id}/details',
            path: {
                'id': id,
            },
            query: {
                'companyId': companyId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
